<template>
  <b-nav 
    class="d-flex flex-row-reverse flex-grow-1">
    <div class="align-self-center mr-4 pr-4">
      <Form 
        class="d-flex"
        @submit="() => null">
        <div 
          v-if="isAnalist() && planMode"
          class="EditMode d-flex align-items-center mr-3">
          <span class="mr-2">PLAN MODE</span>
          <ToggleSwitch 
            class="mb-0" 
            v-model="editMode" />
        </div>
        <FormField 
          class="mr-3"
          v-model="yearModel"
          v-bind="year" />
        <FormField 
          class="mr-3"
          v-model="accessModel"
          v-bind="access"/>
        <FormField 
          v-model="forecastModel"
          v-bind="forecast"/>
      </Form>
    </div>
  </b-nav>
</template>

<script>

import Form from 'molecule/form/Form'
import FormField from 'molecule/form/FormField'
import ToggleSwitch from 'molecule/form/ToggleSwitch'
import { mapGetters, mapMutations } from 'vuex'

import { isAnalist } from 'service/auth'

import { dropdown } from '@/config/inkomensdecielen'

export default {
  components: {
    Form, FormField, ToggleSwitch
  },
  data() {
    return {
      year: {
        type: 'select',
        label: null,
        novalidate: true,
        options: dropdown.map(optie => {
          return {
            value: optie,
            text: optie
          }
        })
        // [
        //   {
        //     value: '2020',
        //     text: '2020'
        //   },
        //   {
        //     value: '2025',
        //     text: '2025'
        //   },
        //   {
        //     value: '2030',
        //     text: '2030'
        //   }
        // ]
      },
      access: {
        type: 'select',
        label: null,
        novalidate: true,
        options: [
          {
            value: 'public',
            text: 'Publiek'
          },
          {
            value: 'private',
            text: 'Privaat'
          }
        ]
      },
      forecast: {
        type: 'select',
        label: null,
        novalidate: true,
        options: [
          {
            value: 'determinative',
            text: 'Bepalende indicatie'
          },
          {
            value: 'inhabitants',
            text: 'Bewoners'
          },
          {
            value: 'visitors',
            text: 'Bezoekers'
          },
          {
            value: 'commuters',
            text: 'Forenzen'
          }
        ]
      }
    }
  },
  computed: {
    ...mapGetters('map', [
      'getForecastStatus',
      'getEditMode'
    ]),
    ...mapGetters('config', {
      planMode: 'planmode'
    }),
    editMode: {
      get() {
        return this.getEditMode
      },
      set (value) {
        this.setEditMode({ enabled: value })
      }
    },
    yearModel: {
      get() {
        return this.getForecastStatus.year
      },
      set (value) {
        this.updateForecastStatus({ year: value })
      }
    },
    accessModel: {
      get() {
        return this.getForecastStatus.access
      },
      set (value) {
        this.updateForecastStatus({ access: value })
      }
    },
    forecastModel: {
      get() {
        return this.getForecastStatus.forecast
      },
      set (value) {
        this.updateForecastStatus({ forecast: value })
      }
    }
  },
  methods: {
    ...mapMutations('map', [
      'updateForecastStatus',
      'setEditMode'
    ]),
    isAnalist
  }
}
</script>

<style>
.EditMode {
  color: white;
}
</style>
